module.exports = __webpack_public_path__ + "static/media/sazmanFny.32f61c11.webp";